export function formatNumberWithSpaces(num?: number | null): string {
  if (num == null) return 'x';
  return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
}
